import styled from 'styled-components'

import {
  BREAK_POINT_MD, BREAK_POINT_SM,
} from '@CSSVars/variables'
import {
  TEXT_GREY,
} from '@CSSVars/colors'


export const _ChartWrapper = styled.div`
  width: 100%;
  overflow: hidden;

  .recharts-legend-wrapper {
    width: 500px !important;
    right: auto !important;
    left: 170px !important;
  }
  .recharts-legend-item {
    display: inline-block !important;
    width: 50%;
    margin-right: 0 !important;
    svg {
      margin-right: 12px !important;
    }
  }

  .recharts-legend-item-text {
    position: relative;
    top: 2px;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    .recharts-legend-wrapper {
      width: 170px !important;
    }
    .recharts-legend-item {
      width: 100% !important;
    }
  }

  @media screen and (max-width: ${BREAK_POINT_SM}) {
    .recharts-legend-wrapper {
      left: 135px !important;
    }
  }

  @media screen and (max-width: 374px) {
    .recharts-legend-wrapper {
      left: 125px !important;
    }
  }
`

export const _LegendItemCopy = styled.div`
  margin-bottom: 8px;
  margin-top: 8px;
  display: inline-flex;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;


  span {
    margin-left: 12px;
    line-height: 24px;
    color: ${TEXT_GREY};
    font-size: 14px;
  }
`

